import { cn } from '@/lib/utils';

export const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    aria-hidden
    className={cn('animate-pulse rounded-md bg-surface-muted', className)}
    {...props}
  />
);
